export const Category = {
    SKILL: "skils",
    KNOWLEDGE: "knowledge",
    MINDSET: "mindset",
    TOOL: "tool",
};

export const SessionStatus = {
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
};

